export const faqs = [
  {
    q: "5.1吃瓜主要做什么内容？",
    a: "我们专注娱乐事件盘点与大瓜合集梳理，把近期受到关注的热点按事件热度与时间线整理成可读内容，让你不用翻十几条碎片消息，也能一次看懂某个事件的来龙去脉。",
  },
  {
    q: "站内的盘点内容多久更新一次？",
    a: "焦点盘点与热度榜在工作日基本保持每日更新，事件时间线会在出现关键进展时补充节点。遇到重大事件，我们会在当天增加一次专题梳理，把新进展合并进原有脉络里。",
  },
  {
    q: "我看到的信息可靠吗？会写来源吗？",
    a: "我们只梳理已经公开传播、可被多方交叉验证的信息，并在正文中标注时间节点。对于尚未证实的传闻，我们会明确标注「待确认」，不把它当成结论来写。",
  },
  {
    q: "可以投稿自己关注的瓜吗？",
    a: "当然可以。页面底部的爆料线索表单就是为这件事准备的，你可以填写事件关键词、大致时间与线索来源。被采纳的线索我们会优先纳入盘点排期。",
  },
  {
    q: "为什么有些事件看起来没有后续？",
    a: "娱乐事件的推进节奏并不均匀，有些争议会在几天内自然降温，也有些需要等待相关方的正式回应的。我们会在时间线里保留「待续」标记，一旦有新进展就补上。",
  },
  {
    q: "能不能只看某一类内容？",
    a: "可以。热门事件汇总区支持按「影视剧集、综艺前线、音乐现场、品牌联名、明星动态、短剧出海」分类筛选，也可以直接用关键词搜索，快速定位你关心的方向。",
  },
];